import React, { Component } from 'react';
import { connect } from 'react-redux';
import Divider from 'widgets/Divider';
import PropTypes from 'prop-types';
import PageTitle from 'components/PageTitle';
import EditableLabel from 'components/EditableLabel';
import { FormattedMessage, FormattedHTMLMessage, injectIntl } from 'react-intl';
import { notify } from 'redux/actions/notice';
import { updateAccountUser } from 'redux/actions/account';
import { isValidEmail } from 'libs/validator';
import { getSocialLoginStatus } from 'libs/auth';
import colors from 'assets/styles/jsVariables/colors';
import {
  clickMenuSettings
} from 'libs/cleverTap';
import './AccountContent.scss';

function validateEmail(email, intl) {
  if (!email || !email.trim()) {
    return intl.formatMessage({ id: 'views.account.accountContent.editableLabel.emptyField.validation.message' });
  } else if (!isValidEmail(email)) {
    return intl.formatMessage({ id: 'views.account.accountContent.editableLabel.emailField.validation.message' });
  }
  return '';
}

function validatePassword(password, intl) {
  if (!password || !password.trim()) {
    return intl.formatMessage({ id: 'views.account.accountContent.editableLabel.emptyField.validation.message' });
  } else if (password.length < 6) {
    return intl.formatMessage({ id: 'views.account.accountContent.editableLabel.passwordField.validation.message' });
  }
  return '';
}

export class AccountContent extends Component {
  constructor(props) {
    super(props);
    const { intl } = props;
    const EMAIL_UPDATE_MESSAGE = intl.formatMessage({ id: 'views.account.accountContent.editableLabel.email.update.message' });
    const PASSWORD_UPDATE_MESSAGE = intl.formatMessage({ id: 'views.account.accountContent.editableLabel.password.update.message' });
    this.fieldMsgMap = {
      emailField: EMAIL_UPDATE_MESSAGE,
      passwordField: PASSWORD_UPDATE_MESSAGE
    };
  }

  componentDidMount() {
    clickMenuSettings();
  }

  handleChange = (valueObject, field) => {
    this.props.updateAccountUser(valueObject, Object.keys(valueObject)[0], () => {
      this.showSuccessNotification(this.fieldMsgMap[field]);
    });
  }

  showSuccessNotification = (message) => {
    this.props.notify({ message });
  }

  render() {
    const { auth, account, intl } = this.props;
    const isSocialLogin = getSocialLoginStatus(auth.userId);
    return (
      <div className="Account__Settings">
        <PageTitle
          title={<FormattedMessage id="views.account.accountContent.pageTitle" />}
          upperCase={false}
          labelStyle={{
            fontSize: '22px',
            color: colors.averageGrey,
            fontWeight: 500,
            letterSpacing: '0.25px',
            }}
          innerDivStyle={{ marginTop: '41px' }}
          dividerStyle={{ marginTop: '9px', marginLeft: '-3px', marginBottom: '12px' }}
        />
        <div className="Account__Description">
          <FormattedHTMLMessage id="views.account.accountContent.description" />
        </div>
        <div
          style={{
            marginTop: '26px',
            marginBottom: '26px',
            padding: 30,
            paddingBottom: !isSocialLogin ? 30 : 0,
            background: 'white',
            borderRadius: 10,
            boxShadow: '0 2px 5px 1px rgba(176,176,176,0.5)'
          }}
        >
          <EditableLabel
            tabIndex="-1"
            title={intl.formatMessage({ id: 'views.account.accountContent.editableLabel.titleAndLabel.email.title' })}
            value={auth.email}
            editLabel={intl.formatMessage({ id: 'views.account.accountContent.editableLabel.sideLabel.email.editLink' })}
            disabled={account.isFetching}
            isSocialLogin={isSocialLogin}
            validation={validateEmail}
            modalOnClick
            style={{
              paddingBottom: 30
            }}
            noteText={intl.formatMessage({ id: 'views.account.accountContent.editableLabel.email.noteText' })}
            onSaveChanges={val => this.handleChange({ email: val }, 'emailField')}
            saveButtonLabel={intl.formatMessage({ id: 'views.account.accountContent.editableLabel.saveButton' })}
            cancelButtonLabel={intl.formatMessage({ id: 'views.account.accountContent.editableLabel.cancelButton' })}
            noteHeading={intl.formatMessage({ id: 'views.account.accountContent.editableLabel.noteHeading' })}
          />
          {
            !isSocialLogin &&
            <React.Fragment>
              <Divider
                style={{
                  background: colors.lightestGrey,
                  marginLeft: -30,
                  marginRight: -30
                }}
              />
              <EditableLabel
                tabIndex="-1"
                title={intl.formatMessage({ id: 'views.account.accountContent.editableLabel.titleAndLabel.password.title' })}
                modalOnClick
                value="••••••••••••"
                clearValueOnEdit
                style={{
                  marginTop: 30
                }}
                editLabel={intl.formatMessage({ id: 'views.account.accountContent.editableLabel.sideLabel.password.editLink' })}
                disabled={account.isFetching}
                validation={validatePassword}
                noteText={intl.formatMessage({ id: 'views.account.accountContent.editableLabel.password.noteText' })}
                onSaveChanges={val => this.handleChange({ password: val }, 'passwordField')}
                saveButtonLabel={intl.formatMessage({ id: 'views.account.accountContent.editableLabel.saveButton' })}
                cancelButtonLabel={intl.formatMessage({ id: 'views.account.accountContent.editableLabel.cancelButton' })}
                noteHeading={intl.formatMessage({ id: 'views.account.accountContent.editableLabel.noteHeading' })}
              />
            </React.Fragment>
          }
        </div>
      </div>
    );
  }
}

AccountContent.propTypes = {
  auth: PropTypes.object.isRequired,
  account: PropTypes.object.isRequired,
  updateAccountUser: PropTypes.func.isRequired,
  notify: PropTypes.func.isRequired,
  intl: PropTypes.object.isRequired
};

function mapStateToProps({ auth, account }) {
  return {
    auth: auth.info && auth.info.user,
    account
  };
}
export default connect(mapStateToProps,
  {
    updateAccountUser,
    notify
  })(injectIntl(AccountContent));



// WEBPACK FOOTER //
// ./src/views/Account/AccountContent.jsx